module.exports = __webpack_public_path__ + "img/onlineteacher.77a6027c.png";